/*
  META PIXEL — jedyne miejsce w aplikacji, ktore dotyka fbq (konwersje kampanii na FB/IG).

  Cykl zycia prowadzi analytics.ts: pixel rusza razem z PostHogiem, dopiero po zgodzie na cookies
  (ta sama podstawa prawna — art. 399 PKE, art. 6 ust. 1 lit. a RODO; polityka prywatnosci par.
  "Reklamy na Facebooku i Instagramie"). Wariant scisly: skrypt Mety nie laduje sie wcale przed
  zgoda, a nie "laduje sie z consent revoke" — Meta nie dostaje nawet wizyty osoby, ktora odmowila.

  Kod z Menedzera zdarzen strzela PageView bez pytania o zgode, dlatego wzielismy z niego tylko ID.
  Na devie skrypt sie nie laduje (nie zasmiecamy zbioru danych zdarzeniami z localhosta); e2e
  czyta wtedy uchwyt `__metaEvents`.
*/

const META_PIXEL_ID = '1438713358227558';

type Fbq = ((...args: unknown[]) => void) & { callMethod?: (...a: unknown[]) => void; queue: unknown[][]; loaded: boolean; version: string; push: Fbq };
type MetaWindow = { fbq?: Fbq; _fbq?: Fbq; __metaEvents?: { event: string; props?: Record<string, unknown> }[] };
const w = () => window as unknown as MetaWindow;

let active = false;

/** Standardowy loader Mety, przepisany z wklejonego kodu bez `init`/`track` (te wolamy sami, po zgodzie). */
function loadFbq() {
  if (w().fbq) return;
  const n = function (...args: unknown[]) {
    if (n.callMethod) n.callMethod(...args);
    else n.queue.push(args);
  } as Fbq;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  w().fbq = n;
  w()._fbq ??= n;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  n('init', META_PIXEL_ID);
}

function send(event: string, props?: Record<string, unknown>) {
  if (!active) return;
  (w().__metaEvents ??= []).push(props ? { event, props } : { event });
  if (import.meta.env.DEV) return;
  w().fbq?.('track', event, props);
}

export function startMetaPixel() {
  if (active) return;
  active = true;
  if (!import.meta.env.DEV) {
    if (w().fbq) w().fbq!('consent', 'grant');
    else loadFbq();
  }
  // Odslona strony, na ktorej zapadla zgoda — to zwykle landing z reklamy (`fbclid` w adresie).
  metaPageView();
}

/** Skryptu nie da sie "wyladowac" — po cofnieciu zgody pixel przestaje cokolwiek wysylac. */
export function stopMetaPixel() {
  active = false;
  w().fbq?.('consent', 'revoke');
}

/** Odslona strony: pierwsza przy starcie pixela, kolejne przy kazdej zmianie trasy SPA (MetaPageViews). */
export const metaPageView = () => send('PageView');

/*
  Ktore zdarzenia produktowe sa konwersjami kampanii. Standardowe nazwy Mety, nie wlasne:
  tylko na standardowe da sie od razu optymalizowac kampanie.
*/
export function metaConversion(event: string) {
  // Scenariusz, nie cala lekcja: to pierwsza wartosc, jaka nauczyciel dostaje, i pada w kilkanascie sekund.
  if (event === 'scenario_ready') send('Lead');
  // Cena oferty to 10 zl (100 kr) — wartosc pozwala liczyc w Mecie "koszt zamiaru zakupu".
  if (event === 'topup_clicked') send('InitiateCheckout', { value: 10, currency: 'PLN' });
}
